import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on ouvrir le coffre sans casser les finitions ?",
    answer: "Oui, dans la plupart des cas. Les coffres modernes sont équipés de trappes de visite ou de caches latéraux clipsés qui se démontent sans outillage agressif. Pour les coffres plus anciens, nous utilisons des outils fins pour décoller les caches sans fissurer le PVC ou l'aluminium. Notre technicien évalue le mode d'accès le plus adapté avant de commencer pour éviter toute casse.",
  },
  {
    question: "Quelle est la différence entre un coffre bloc-baie et un coffre extérieur ?",
    answer: "Un coffre bloc-baie est intégré à la menuiserie de la fenêtre : il fait partie du même ensemble et ne peut pas être déposé indépendamment sans démonter la baie. Un coffre extérieur est posé au-dessus de la fenêtre, sur le mur ou dans le linteau, et peut être démonté ou remplacé sans toucher à la fenêtre. Les deux types demandent des techniques d'intervention différentes.",
  },
  {
    question: "Combien de temps dure l'intervention sur un coffre ?",
    answer: "Une réparation simple (remplacement d'un roulement, d'une équerre, d'un joint) prend entre 30 et 60 minutes. Un remplacement partiel de coque ou un renforcement des fixations prend entre 1h et 2h. Un remplacement complet du coffre peut prendre 2h à 4h selon le type de pose et l'accessibilité. Nous intervenons en un seul passage dans la majorité des cas.",
  },
  {
    question: "Quel est le prix d'une réparation de coffre ?",
    answer: "Le tarif dépend de la nature de l'intervention. Une réparation ciblée (pièce interne, redressage, joint) est facturée au forfait de déplacement majoré du coût de la pièce. Un remplacement de coffre complet inclut le démontage, la pose du nouveau caisson, le calage et l'étanchéification. Nous établissons un devis détaillé et gratuit sur place avant de commencer. Aucun tarif inventé, aucune surprise.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Questions fréquentes sur la réparation de coffre
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-brand-border rounded-xl overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-brand-light/50 transition-colors"
              >
                <span className="font-semibold text-brand-blue text-sm md:text-base pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-brand-cyan text-xl transition-transform shrink-0 ${open === i ? "rotate-180" : ""}`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm text-brand-text leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}